import { isExcelClaudeOpusEnabled } from "../shared/featureFlags/excelExecutorModel";
import { resolveModelPickerOverride } from "../shared/modelPicker/selectionStore";
import {
  FLAGGED_EXECUTOR_MODEL_ID,
  resolveExecutorModel,
  type ExecutorModelConfig,
} from "./providers/registry";

/**
 * Snapshots one executor configuration for a complete run.
 *
 * Internal picker overrides are honored only while their fail-closed ConfigCat
 * gate is active. Otherwise the existing excelUseClaudeOpus routing remains
 * authoritative.
 */
export function resolveEffectiveExcelExecutorModel(): ExecutorModelConfig {
  const override = resolveModelPickerOverride("excel");
  if (!override) {
    return resolveExecutorModel(
      isExcelClaudeOpusEnabled() ? FLAGGED_EXECUTOR_MODEL_ID : null
    );
  }

  const base = resolveExecutorModel(override.entry.id);
  return {
    ...base,
    reasoningEffort: override.effort,
    ...(override.entry.allowedModes?.includes("pro") && override.mode
      ? { reasoningMode: override.mode }
      : { reasoningMode: undefined }),
  };
}
